(() => {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-c2g-fit-tab]');
    if (!tab) return;

    const fitment = tab.closest('.c2g-home-fitment');
    if (!fitment) return;

    const activeKind = tab.dataset.c2gFitTab;
    fitment.querySelectorAll('[data-c2g-fit-tab]').forEach((item) => {
      item.setAttribute('aria-selected', String(item === tab));
    });
    fitment.querySelectorAll('[data-c2g-fit-panel]').forEach((panel) => {
      const isActive = panel.dataset.c2gFitPanel === activeKind;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    const form = fitment.querySelector('[data-c2g-fitment-form]');
    if (form) form.dataset.activeKind = activeKind;
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-c2g-fitment-form]');
    if (!form) return;

    event.preventDefault();
    const kind = form.dataset.activeKind || 'vehicle';
    const panel = form.querySelector(`[data-c2g-fit-panel="${kind}"]`);
    const values = Array.from(panel?.querySelectorAll('input') || [])
      .map((input) => input.value.trim())
      .filter(Boolean);

    if (kind === 'vehicle') {
      const request = values.length ? values.join(' ') : 'Vehicle tire fitment help';
      window.location.assign(`/pages/contact?fitment=${encodeURIComponent(request)}`);
      return;
    }

    if (values.length) {
      window.location.assign(`/search?type=product&q=${encodeURIComponent(values.join(' '))}`);
      return;
    }

    const fallback = form.dataset[`${kind}Url`];
    window.location.assign(fallback || '/pages/contact');
  });
})();
